import styled from '@emotion/styled';

export const IconButtonBlock = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  box-sizing: border-box;
  border-radius: ${({ theme }) => theme.radii.card};
  border-width: 1px;
  border-style: solid;
  cursor: pointer;
  user-select: none;

  background-color: ${({ theme }) => theme.colors.SurfaceCard};
  border-color: ${({ theme }) => theme.colors.LineStrong};
  color: ${({ theme }) => theme.colors.SurfaceRaisinBlack50};

  transition: all 0.2s ease-in-out;

  &:focus-visible {
    outline: none;
    border-color: ${({ theme }) => theme.colors.AccentJonquil};
  }

  // sizes

  // размер задаётся только прямому потомку — иконка может быть обёрнута
  // (например, бейдж-стрелка рядом с ней), и вложенные svg должны остаться своего размера

  &.sm {
    width: 28px;
    height: 28px;
    border-radius: ${({ theme }) => theme.radii.control};

    > svg {
      width: 16px;
      height: 16px;
    }
  }

  &.md {
    width: 36px;
    height: 36px;

    > svg {
      width: 20px;
      height: 20px;
    }
  }

  &.lg {
    width: 44px;
    height: 44px;

    > svg {
      width: 24px;
      height: 24px;
    }
  }

  // variants

  &.default {
    &:hover {
      background-color: ${({ theme }) => theme.colors.AccentCornsilk};
      border-color: ${({ theme }) => theme.colors.AccentNaplesYellow};
    }

    &:active {
      background-color: ${({ theme }) => theme.colors.AccentNaplesYellow};
      border-color: ${({ theme }) => theme.colors.AccentNaplesYellow};
    }
  }

  &.primary {
    background-color: ${({ theme }) => theme.colors.DarkYellow};
    border-color: ${({ theme }) => theme.colors.DarkYellow};
    color: ${({ theme }) => theme.colors.InkPrimary};

    &:hover {
      background-color: ${({ theme }) => theme.colors.LightGold};
      border-color: ${({ theme }) => theme.colors.LightGold};
    }

    &:active {
      background-color: ${({ theme }) => theme.colors.Gold};
      border-color: ${({ theme }) => theme.colors.Gold};
    }
  }

  &.success {
    color: ${({ theme }) => theme.colors.submit};

    &:hover {
      background-color: ${({ theme }) => theme.colors.submit};
      border-color: ${({ theme }) => theme.colors.submit};
      color: ${({ theme }) => theme.colors.InkOnDark};
    }

    &:active {
      background-color: ${({ theme }) => theme.colors.Green};
      border-color: ${({ theme }) => theme.colors.Green};
      color: ${({ theme }) => theme.colors.InkOnDark};
    }
  }

  // безрамочный вариант для плотных тулбаров: плашки нет, меняется только цвет иконки
  &.ghost {
    background-color: transparent;
    border-color: transparent;
    color: ${({ theme }) => theme.colors.InkPrimary};

    &:hover {
      color: ${({ theme }) => theme.colors.DarkYellow};
    }

    &:active {
      color: ${({ theme }) => theme.colors.Gold};
    }

    // прозрачный бордер варианта перебивает базовое правило — повторяем фокус-рамку здесь
    &:focus-visible {
      border-color: ${({ theme }) => theme.colors.AccentJonquil};
    }
  }

  &.danger {
    color: ${({ theme }) => theme.colors.error};

    &:hover {
      background-color: ${({ theme }) => theme.colors.error};
      border-color: ${({ theme }) => theme.colors.error};
      color: ${({ theme }) => theme.colors.InkOnDark};
    }

    &:active {
      background-color: ${({ theme }) => theme.colors.Red};
      border-color: ${({ theme }) => theme.colors.Red};
      color: ${({ theme }) => theme.colors.InkOnDark};
    }
  }

  // keep after the variants — disabled/loading must win over them

  &.loading {
    pointer-events: none;
  }

  &[disabled] {
    cursor: not-allowed;
    pointer-events: none;

    background-color: ${({ theme }) => theme.colors.SurfaceCard};
    border-color: ${({ theme }) => theme.colors.LineStrong};
    color: ${({ theme }) => theme.colors.SurfaceRomanSilver30};
  }

  &.ghost[disabled] {
    background-color: transparent;
    border-color: transparent;
  }
`;
